var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69961 21.9016C9.89961 19.5016 14.0996 19.5016 15.2996 21.9016M5.93961 17.1016H18.0596C19.4037 17.1016 20.0758 17.1016 20.5892 16.84C21.0408 16.6099 21.4079 16.2427 21.638 15.7911C21.8996 15.2778 21.8996 14.6057 21.8996 13.2616V5.94156C21.8996 4.59744 21.8996 3.92537 21.638 3.41199C21.4079 2.9604 21.0408 2.59324 20.5892 2.36315C20.0758 2.10156 19.4037 2.10156 18.0596 2.10156H5.93961C4.59548 2.10156 3.92342 2.10156 3.41003 2.36315C2.95844 2.59324 2.59129 2.9604 2.36119 3.41199C2.09961 3.92537 2.09961 4.59744 2.09961 5.94156V13.2616C2.09961 14.6057 2.09961 15.2778 2.36119 15.7911C2.59129 16.2427 2.95844 16.6099 3.41003 16.84C3.92342 17.1016 4.59548 17.1016 5.93961 17.1016Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvWhite);
export default __webpack_public_path__ + "static/media/tv-white.ef215bf9aea0a4e060bedaa87f16abed.svg";
export { ForwardRef as ReactComponent };